 <template>
  <b-col cols="6" lg="4"  class="p-0 mb-3 pl-1 pr-1">
    <b-card 
      v-bind:img-src="getImage"
      img-bottom
      overlay
      border-variant="white"
      variant="white"     
      v-on:click="go('/app/category/' + ShopCategory.id)">

        <div class="half-circle" alt=""></div>
        <div v-html="getTitle" class="product-description text-uppercase"></div>
      
    </b-card>
  </b-col>
</template>

 <script>
export default {
  name: "ShopCategoryItem",
  props: ["ShopCategory", "CardOptions","index"],
  methods: {
    go: function(route) {
      /* go to category... */
      // console.log(route);
      this.$router.push(route);
      
    }
  },
  computed: {
    getSelectedLanguage() {
      return this.$store.getters.getLanguage;
    },
    getTitle() {
      // console.log(this.ShopCategory);
      return this.ShopCategory.title;
    },
    getDescription() {
      return this.ShopCategory.shortDescription;
    },
    getImage() {
      // TODO: FIXME Image array ?
      return (this.$store.getters.getWebServerBaseUrl + this.ShopCategory.images[0]);
    },    
    getProductImage() {
      //console.log(this.getImage );      
            return { 'background-image': 'url("' + this.getImage + '")' }
    },
    getColor(){
      return 'color:'+ this.ShopCategory.color + ';';
    },
    
  },
  mounted(){
    //console.log(this.ShopCategory);
    //console.log('Key:', this.index);
    
  }
};
</script> 

